import React, { useEffect, useState } from "react";
import "./UpcomingEvents.css";
import { useNavigate } from 'react-router-dom';

const UpcomingEvents = ({ apiUrl }) => {
  const [eventsByDate, setEventsByDate] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.log("❌ No token found");
          setLoading(false);
          setEventsByDate([]);
          return;
        }
        
        console.log("🔍 Fetching events from:", `${apiUrl}/api/events`);
        console.log("🔑 Token exists:", !!token);
        console.log("🌐 API URL being used:", apiUrl);
        
        const response = await fetch(`${apiUrl}/api/events`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        // Check if response is ok
        if (!response.ok) {
          console.error('API Error:', response.status, response.statusText);
          const errorText = await response.text();
          console.error('Error response:', errorText);
          throw new Error(`API Error: ${response.status} - ${response.statusText}`);
        }
        
        const data = await response.json();


        if (Array.isArray(data)) {
          const today = new Date().setHours(0, 0, 0, 0); // Current date without time

          // Filter out past events
          const futureEvents = data.filter((event) => new Date(event.date).setHours(0, 0, 0, 0) >= today);

          // Group future events by date
          const groupedEvents = futureEvents.reduce((acc, event) => {
            const eventDate = event.date.split("T")[0]; // Extract YYYY-MM-DD
            if (!acc[eventDate]) {
              acc[eventDate] = [];
            }
            acc[eventDate].push(event);
            return acc;
          }, {});

          // Sort dates by the number of events (busiest first)
          const sortedDates = Object.entries(groupedEvents)
            .sort((a, b) => {
              const countDiff = b[1].length - a[1].length; // Compare event counts
              if (countDiff !== 0) return countDiff; // Prioritize busier days
              return new Date(a[0]) - new Date(b[0]); // If equal, sort by date (earliest first)
            })
            .slice(0, 5); // Get the top 5 busiest upcoming days

          setEventsByDate(sortedDates);
        } else {
          setEventsByDate([]);
        }
        setLoading(false);
             } catch (error) {
         console.error("Error fetching events:", error);
         if (error.response && error.response.status === 403) {
           console.error("Authentication failed - token may be expired");
         }
         setLoading(false);
         setEventsByDate([]);
       }
    };

    fetchEvents();
  }, [apiUrl]); // Dependency on apiUrl

  if (loading) {
    return (
      <div className="upcoming-events-loading">
        <h5 className="upcoming-events-title">
          Upcoming Events
        </h5>
        <p>Loading events...</p>
      </div>
    );
  }

  return (
    <div className="upcoming-events-card-content">
      <div className="upcoming-events-card">
        <div className="upcoming-events-header">
          <h5 className="upcoming-events-title">
            Les Jours les plus chargés
          </h5>
          <button 
            onClick={() => navigate(`/events`)} 
            className="upcoming-events-button"
          >
            Voir tout
          </button>
        </div>
        <div className="upcoming-events-content">
          <ul className="upcoming-events-list">
            {eventsByDate.map(([date, events], index) => (
              <li key={index} className="upcoming-events-item">
                <div className="upcoming-events-date">
                  <div className="upcoming-events-date-text">
                    {new Date(date).toLocaleDateString()}
                  </div>
                </div>
                {Object.entries(
                  events.reduce((locations, event) => {
                    if (!locations[event.location]) {
                      locations[event.location] = [];
                    }
                    locations[event.location].push(event.name);
                    return locations;
                  }, {})
                ).map(([location, eventNames], locIndex) => (
                  <div key={locIndex} className="upcoming-events-location">
                    <p className="upcoming-events-location-name">
                      {location}
                    </p>
                    <ul className="upcoming-events-event-names">
                      {eventNames.map((eventName, nameIndex) => (
                        <li key={nameIndex}>- {eventName}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UpcomingEvents;
